<template>
	<div class="warehouse-pos">
		<div class="btnbox">
			<el-button size="small" @click="goSale">销售记录</el-button>
			<el-button size="small" @click="goPromotion">折上折</el-button>
			<el-button size="small" :disabled="!lastReceipt" @click="reprintLast">补打小票</el-button>
		</div>
		<div class="empty-guide" v-if="ready && !warehouseId">
			<div class="empty-title">请先开通云仓</div>
			<div class="empty-desc">开通并通过审核后才能进行 POS 销售。</div>
			<el-button type="primary" @click="goIndex">返回云仓首页</el-button>
		</div>
		<div class="pos-layout" v-if="ready && warehouseId">
			<div class="pos-left">
				<div class="pos-toolbar">
					<el-input ref="scanInput" v-model="barcode" size="small" placeholder="扫码或输入条码后回车"
						clearable @keyup.enter.native="onScan"></el-input>
					<el-input v-model="keyword" size="small" placeholder="搜索款号" clearable
						@keyup.enter.native="onSearch"></el-input>
					<el-button size="small" type="primary" @click="onSearch">查询</el-button>
				</div>
				<div class="manual-row">
					<el-input v-model="manualStyle" size="small" placeholder="款号"></el-input>
					<el-input v-model="manualSize" size="small" placeholder="尺码"></el-input>
					<el-button size="small" @click="onManualAdd">手动添加</el-button>
				</div>
				<div class="card-grid" v-loading="stockLoading">
					<div class="stock-card" v-for="card in cards" :key="card.key" @click="onCardClick(card)">
						<div class="thumb">
							<img v-if="card.product_image" :src="card.product_image">
							<div v-else class="thumb-empty">无图</div>
						</div>
						<div class="meta">
							<div class="style">{{ card.style_number }}</div>
							<div class="price">¥{{ fenToYuan(card.suggest_price != null ? card.suggest_price : card.retail_price) }}</div>
							<div class="retail">吊牌价 ¥{{ fenToYuan(card.retail_price) }}</div>
							<div class="avail">可用 {{ card.available }}<template v-if="sizeSummary(card)"> · {{ sizeSummary(card) }}</template></div>
						</div>
					</div>
					<div class="empty-cards" v-if="!stockLoading && !cards.length">暂无在仓商品</div>
				</div>
				<div class="pager" v-if="stockTotal > 0">
					<el-pagination background layout="prev, pager, next, total" :current-page="stockPage"
						:page-size="stockPageSize" :total="stockTotal" @current-change="handleStockPage"></el-pagination>
				</div>
			</div>
			<div class="pos-right">
				<div class="cart-title">购物车 {{ cart.length }} 行</div>
				<div class="cart-body">
					<el-table ref="cartTable" :data="cart" border size="mini" height="100%" class="cart-table">
						<el-table-column label="款号" min-width="108">
							<template slot-scope="scope">
								<span>{{ scope.row.style_number }}</span>
								<el-tag v-if="isOwned(scope.row)" size="mini" type="warning">自有货</el-tag>
							</template>
						</el-table-column>
						<el-table-column prop="size" label="尺码" min-width="56" align="center"></el-table-column>
						<el-table-column label="件数" min-width="72" align="center">
							<template slot-scope="scope">
								<el-input-number v-model="scope.row.quantity" :min="1" :max="scope.row.available || 9999"
									:precision="0" :controls="false" size="mini"></el-input-number>
							</template>
						</el-table-column>
						<el-table-column label="售价" min-width="76" align="center">
							<template slot-scope="scope">
								<el-input v-model="scope.row.sale_price_yuan" size="mini"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="小计" min-width="72" align="center">
							<template slot-scope="scope">¥{{ lineSale(scope.row) }}</template>
						</el-table-column>
						<el-table-column label="删除" width="64" align="center" fixed="right">
							<template slot-scope="scope">
								<div class="operation_i">
									<span @click="removeCart(scope.$index)">删除</span>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="cart-foot">
					<div>基准实收：¥{{ fenToYuan(cartSaleFen) }}</div>
					<div v-if="previewPromotion">预计优惠：¥{{ fenToYuan(previewDiscountFen) }}（{{ previewPromotionText }}）</div>
					<div>预计实收：¥{{ fenToYuan(previewPayFen) }}</div>
					<div class="sub">预计保证金扣减：¥{{ fenToYuan(cartCostFen) }}（按成本价，与实收无关）</div>
					<el-button type="primary" :disabled="!cart.length" @click="openConfirm">结算</el-button>
				</div>
			</div>
		</div>

		<el-dialog title="确认收款" :visible.sync="confirmShow" width="720px" :before-close="closeConfirm">
			<div v-if="confirmShow" class="confirm-box">
				<el-table :data="cart" border size="mini" style="width: 100%" max-height="280">
					<el-table-column label="款号" min-width="120">
						<template slot-scope="scope">
							<span>{{ scope.row.style_number }}</span>
							<el-tag v-if="isOwned(scope.row)" size="mini" type="warning">自有货</el-tag>
						</template>
					</el-table-column>
					<el-table-column prop="size" label="尺码" width="70" align="center"></el-table-column>
					<el-table-column prop="quantity" label="件数" width="70" align="center"></el-table-column>
					<el-table-column label="售价" width="90" align="center">
						<template slot-scope="scope">¥{{ scope.row.sale_price_yuan }}</template>
					</el-table-column>
					<el-table-column label="小计" width="90" align="center">
						<template slot-scope="scope">¥{{ lineSale(scope.row) }}</template>
					</el-table-column>
				</el-table>
				<div class="confirm-sum">
					<div>基准实收：¥{{ fenToYuan(cartSaleFen) }}</div>
					<div v-if="previewPromotion">预计优惠：−¥{{ fenToYuan(previewDiscountFen) }}（{{ previewPromotionText }}）</div>
					<div class="pay-fen">预计实收 ¥{{ fenToYuan(previewPayFen) }}</div>
					<div class="sub">预计保证金扣减：¥{{ fenToYuan(cartCostFen) }}（按成本价，与实收无关）</div>
				</div>
				<div class="confirm-tip" v-if="ownedCount > 0">含自有货 {{ ownedCount }} 件（已买断，不扣保证金）</div>
				<div class="confirm-tip warn" v-if="confirmLowCount > 0">有 {{ confirmLowCount }} 件低于成本价，请确认</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="closeConfirm">取消</el-button>
				<el-button type="primary" :loading="confirmSubmitting" @click="onConfirmPay">确认收款 ¥{{ fenToYuan(previewPayFen) }}</el-button>
			</div>
		</el-dialog>

		<el-dialog title="结算成功" :visible.sync="receiptShow" width="860px" :before-close="closeReceipt">
			<div v-if="receiptShow" class="receipt-box">
				<p class="split-tip" v-if="receiptSplit">已自动按批次/供应商拆单</p>
				<p class="low-tip" v-if="receiptLowCount > 0">本单有 {{ receiptLowCount }} 件低于拿货价</p>
				<div class="ticket" id="cw-ticket">
					<div class="ticket-name">{{ warehouseName || '云仓' }}</div>
					<div>单号 {{ receiptSettleNo || '-' }}</div>
					<div>{{ receiptTime || '' }}</div>
					<div class="ticket-line" v-for="(row, idx) in receiptItems" :key="idx">
						<span>{{ row.style_number }} {{ row.size }} ×{{ row.quantity }}</span>
						<span>¥{{ fenToYuan(row.sale_price) }}</span>
					</div>
					<div v-if="receiptDiscount > 0">优惠 {{ receiptPromotionText }} −¥{{ fenToYuan(receiptDiscount) }}</div>
					<div>实收 ¥{{ fenToYuan(receiptTotal) }}</div>
					<div>支付 现金/其他</div>
				</div>
				<el-table :data="receiptItems" border size="mini" style="width: 100%">
					<el-table-column prop="style_number" label="款号" min-width="110"></el-table-column>
					<el-table-column prop="size" label="尺码" width="70" align="center"></el-table-column>
					<el-table-column prop="quantity" label="件数" width="70" align="center"></el-table-column>
					<el-table-column label="基准价" width="90" align="center">
						<template slot-scope="scope">¥{{ fenToYuan(scope.row.base_price != null ? scope.row.base_price : scope.row.sale_price) }}</template>
					</el-table-column>
					<el-table-column label="实收价" width="90" align="center">
						<template slot-scope="scope">¥{{ fenToYuan(scope.row.sale_price) }}</template>
					</el-table-column>
					<el-table-column label="综合拿货价" width="150" align="center">
						<template slot-scope="scope">
							<span v-if="isOwned(scope.row)">买价 ¥{{ fenToYuan(costRefOf(scope.row)) }}（自有货）</span>
							<span v-else>¥{{ fenToYuan(costRefOf(scope.row)) }}</span>
						</template>
					</el-table-column>
					<el-table-column label="利润" width="100" align="center">
						<template slot-scope="scope">
							<span :class="lineProfitFen(scope.row) < 0 ? 'profit-neg' : 'profit-pos'">¥{{ fenToYuan(lineProfitFen(scope.row)) }}</span>
						</template>
					</el-table-column>
				</el-table>
				<div class="receipt-total">
					<div>基准实收：¥{{ fenToYuan(receiptBase) }}</div>
					<div v-if="receiptDiscount > 0">优惠：¥{{ fenToYuan(receiptDiscount) }}</div>
					<div>实收合计：¥{{ fenToYuan(receiptTotal) }}</div>
					<div>保证金扣减：{{ receiptCost > 0 ? '¥' + fenToYuan(receiptCost) : '—' }}</div>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="printReceipt">打印小票</el-button>
				<el-button type="primary" @click="closeReceipt">确定</el-button>
			</div>
		</el-dialog>

		<el-dialog :title="'选择尺码 · ' + (sizePickCard.style_number || '')" :visible.sync="sizePickShow"
			width="480px" :before-close="closeSizePick">
			<div class="size-pick" v-if="sizePickShow">
				<div class="size-chip" v-for="item in sizePickCard.sizes" :key="item.key"
					:class="{ disabled: item.available <= 0 }" @click="onPickSize(item)">
					<strong>{{ item.size }}</strong>
					<span>可用 {{ item.available }}</span>
					<span>¥{{ fenToYuan(item.suggest_price != null ? item.suggest_price : item.retail_price) }}</span>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { fenToYuan, yuanToFen, apiMsg } from './money.js'

	export default {
		name: 'WarehousePos',
		inject: ['appdata'],
		data() {
			return {
				ready: false,
				warehouseId: '',
				warehouseName: '',
				promotions: [],
				lastReceipt: null,
				barcode: '',
				keyword: '',
				manualStyle: '',
				manualSize: '',
				cards: [],
				stockPage: 1,
				stockPageSize: 50,
				stockTotal: 0,
				stockLoading: false,
				cart: [],
				confirmShow: false,
				confirmSubmitting: false,
				confirmItems: [],
				receiptShow: false,
				receiptItems: [],
				receiptTotal: 0,
				receiptBase: 0,
				receiptDiscount: 0,
				receiptCost: 0,
				receiptSplit: false,
				receiptLowCount: 0,
				receiptSettleNo: '',
				receiptTime: '',
				receiptPromotion: null,
				sizePickShow: false,
				sizePickCard: {}
			}
		},
		computed: {
			cartSaleFen() {
				var self = this
				return this.cart.reduce(function(sum, row) {
					return sum + self.lineSaleFen(row)
				}, 0)
			},
			cartCostFen() {
				var self = this
				return this.cart.reduce(function(sum, row) {
					if (self.isOwned(row)) {
						return sum
					}
					return sum + Number(row.composite_cost || 0) * Number(row.quantity || 0)
				}, 0)
			},
			ownedCount() {
				var self = this
				return this.cart.reduce(function(sum, row) {
					return self.isOwned(row) ? sum + Number(row.quantity || 0) : sum
				}, 0)
			},
			confirmLowCount() {
				var self = this
				return this.cart.reduce(function(sum, row) {
					var price = yuanToFen(row.sale_price_yuan)
					var cost = self.costRefOf(row)
					if (!isNaN(price) && price > 0 && price < cost) {
						return sum + Number(row.quantity || 0)
					}
					return sum
				}, 0)
			},
			cartQty() {
				return this.cart.reduce(function(sum, row) {
					return sum + Number(row.quantity || 0)
				}, 0)
			},
			previewPromotion() {
				var qty = this.cartQty
				var base = this.cartSaleFen
				var hit = null
				this.promotions.forEach(function(row) {
					if (Number(row.state) !== 1) {
						return
					}
					var ok = Number(row.type) === 1 ? qty >= Number(row.threshold) : base >= Number(row.threshold)
					if (!ok) {
						return
					}
					if (!hit || Number(row.discount) < Number(hit.discount)) {
						hit = row
					}
				})
				return hit
			},
			previewDiscountFen() {
				return Math.max(0, this.cartSaleFen - this.previewPayFen)
			},
			previewPayFen() {
				var promo = this.previewPromotion
				if (!promo) {
					return this.cartSaleFen
				}
				var rate = Number(promo.discount)
				return this.cart.reduce(function(sum, row) {
					var unit = yuanToFen(row.sale_price_yuan)
					if (isNaN(unit) || unit < 0) {
						unit = 0
					}
					return sum + Math.round(unit * rate / 1000) * Number(row.quantity || 0)
				}, 0)
			},
			previewPromotionText() {
				return this.promoText(this.previewPromotion)
			},
			receiptPromotionText() {
				return this.promoText(this.receiptPromotion)
			}
		},
		mounted() {
			this.lastReceipt = this.readLastReceipt()
			this.loadWarehouse()
		},
		beforeDestroy() {
			if (this.cartResizeObserver) {
				this.cartResizeObserver.disconnect()
			}
		},
		methods: {
			fenToYuan: fenToYuan,
			bindCartResize() {
				if (typeof ResizeObserver === 'undefined') {
					return
				}
				if (this.cartResizeObserver) {
					this.cartResizeObserver.disconnect()
				}
				var self = this
				this.cartResizeObserver = new ResizeObserver(function() {
					self.$nextTick(function() {
						if (self.$refs.cartTable && self.$refs.cartTable.doLayout) {
							self.$refs.cartTable.doLayout()
						}
					})
				})
				var body = this.$el && this.$el.querySelector('.cart-body')
				if (body) {
					this.cartResizeObserver.observe(body)
				}
			},
			goIndex() {
				this.$router.push('/buyer/warehouse/index')
			},
			goSale() {
				this.$router.push('/buyer/warehouse/sale')
			},
			goPromotion() {
				this.$router.push('/buyer/warehouse/promotion')
			},
			promoText(row) {
				if (!row) {
					return ''
				}
				if (row.type_str && row.threshold_display && row.discount_display) {
					return row.type_str + row.threshold_display + row.discount_display + '折'
				}
				var type = Number(row.type) === 1 ? '满' + row.threshold + '件' : '满¥' + this.fenToYuan(row.threshold)
				var zhe = Number(row.discount) / 100
				var zheText = zhe % 1 === 0 ? String(zhe) : String(parseFloat(zhe.toFixed(2)))
				return type + zheText + '折'
			},
			readLastReceipt() {
				try {
					var raw = window.localStorage.getItem('cw_last_receipt')
					return raw ? JSON.parse(raw) : null
				} catch (e) {
					return null
				}
			},
			saveLastReceipt() {
				var data = {
					warehouseName: this.warehouseName,
					items: this.receiptItems,
					total: this.receiptTotal,
					base: this.receiptBase,
					discount: this.receiptDiscount,
					cost: this.receiptCost,
					split: this.receiptSplit,
					lowCount: this.receiptLowCount,
					settleNo: this.receiptSettleNo,
					time: this.receiptTime,
					promotion: this.receiptPromotion
				}
				this.lastReceipt = data
				try {
					window.localStorage.setItem('cw_last_receipt', JSON.stringify(data))
				} catch (e) {}
			},
			applyReceipt(data) {
				this.receiptItems = data.items || []
				this.receiptTotal = data.total_amount != null ? data.total_amount : (data.total || 0)
				this.receiptBase = data.total_base_amount != null ? data.total_base_amount : (data.base || this.receiptTotal)
				this.receiptDiscount = data.discount_amount != null ? data.discount_amount : (data.discount || 0)
				var self = this
				this.receiptCost = data.cost != null ? data.cost : this.receiptItems.reduce(function(sum, row) {
					if (self.isOwned(row)) {
						return sum
					}
					return sum + self.costRefOf(row) * Number(row.quantity || 0)
				}, 0)
				this.receiptSplit = data.split != null ? data.split : false
				this.receiptLowCount = Number(data.low_price_count != null ? data.low_price_count : (data.lowCount || 0))
				this.receiptSettleNo = data.settle_no || data.settleNo || ''
				this.receiptTime = data.settle_time_str || data.time || ''
				this.receiptPromotion = data.promotion || null
				this.receiptShow = true
			},
			reprintLast() {
				if (!this.lastReceipt) {
					this.$message.warning('暂无可补打小票')
					return
				}
				this.applyReceipt(this.lastReceipt)
			},
			printReceipt() {
				window.print()
			},
			refreshBalance() {
				if (this.appdata && this.appdata.oninfo) {
					this.appdata.oninfo()
				}
			},
			lineSaleFen(row) {
				var price = yuanToFen(row.sale_price_yuan)
				if (isNaN(price) || price < 0) {
					price = 0
				}
				return price * Number(row.quantity || 0)
			},
			lineSale(row) {
				return this.fenToYuan(this.lineSaleFen(row))
			},
			isOwned(row) {
				if (!row) {
					return false
				}
				if (Number(row.is_owned) === 1) {
					return true
				}
				if (row.is_owned === 0 || row.is_owned === '0') {
					return false
				}
				if (Number(row.buyout_state || 0) === 1) {
					return true
				}
				return row.seller_uid != null && row.seller_uid !== '' && Number(row.seller_uid) === 0
			},
			costRefOf(row) {
				if (this.isOwned(row)) {
					return Number(row.buyout_price || 0)
				}
				return Number(row.composite_cost || 0)
			},
			lineProfitFen(row) {
				return (Number(row.sale_price || 0) - this.costRefOf(row)) * Number(row.quantity || 0)
			},
			rowAvailable(row) {
				return Math.max(0, Number(row.quantity || 0) - Number(row.sold_quantity || 0))
			},
			sizeSortKey(size) {
				var raw = String(size || '').trim().toUpperCase().replace(/\s+/g, '')
				if (!raw) {
					return [2, 0, '']
				}
				var letterRank = {
					XXXS: 1, '3XS': 1, XXS: 2, '2XS': 2, XS: 3,
					S: 4, M: 5, L: 6,
					XL: 7, XXL: 8, '2XL': 8, XXXL: 9, '3XL': 9,
					XXXXL: 10, '4XL': 10, XXXXXL: 11, '5XL': 11
				}
				if (raw === '均码' || raw === 'FREE' || raw === 'F' || raw === 'ONESIZE' || raw === 'OS') {
					return [0, 5.5, raw]
				}
				if (letterRank[raw] != null) {
					return [0, letterRank[raw], raw]
				}
				var num = raw.match(/(\d+(?:\.\d+)?)/)
				if (num) {
					return [1, Number(num[1]), raw]
				}
				return [2, 0, raw]
			},
			compareSize(a, b) {
				var ka = this.sizeSortKey(a)
				var kb = this.sizeSortKey(b)
				if (ka[0] !== kb[0]) {
					return ka[0] - kb[0]
				}
				if (ka[1] !== kb[1]) {
					return ka[1] - kb[1]
				}
				return String(ka[2]).localeCompare(String(kb[2]), 'zh')
			},
			sortSizeCards(list) {
				var self = this
				return (list || []).slice().sort(function(a, b) {
					return self.compareSize(a.size, b.size)
				})
			},
			sizeSummary(card) {
				var names = ((card && card.sizes) || []).filter(function(item) {
					return Number(item.available || 0) > 0 && item.size
				}).map(function(item) {
					return item.size
				})
				if (!names.length) {
					return ''
				}
				if (names.length <= 4) {
					return names.join(' / ')
				}
				return names.slice(0, 4).join(' / ') + ' 等'
			},
			cardKey(style, size) {
				return String(style || '') + '|' + String(size || '')
			},
			aggregateBySize(list) {
				var map = {}
				var order = []
				var self = this
				;(list || []).forEach(function(row) {
					var key = self.cardKey(row.style_number, row.size)
					if (!map[key]) {
						map[key] = {
							key: key,
							stock_id: row.id,
							style_number: row.style_number,
							size: row.size,
							retail_price: row.retail_price,
							suggest_price: row.suggest_price,
							composite_cost: row.composite_cost,
							composite_discount: row.composite_discount,
							cost_discount: row.cost_discount,
							is_owned: row.is_owned,
							buyout_price: row.buyout_price,
							buyout_state: row.buyout_state,
							seller_uid: row.seller_uid,
							product_image: row.product_image,
							available: 0
						}
						order.push(map[key])
					}
					map[key].available += self.rowAvailable(row)
					if (!map[key].product_image && row.product_image) {
						map[key].product_image = row.product_image
					}
				})
				return order
			},
			aggregateByStyle(list) {
				var map = {}
				var order = []
				var self = this
				this.aggregateBySize(list).forEach(function(sizeCard) {
					var key = String(sizeCard.style_number || '')
					if (!map[key]) {
						map[key] = {
							key: key,
							style_number: sizeCard.style_number,
							retail_price: sizeCard.retail_price,
							suggest_price: sizeCard.suggest_price,
							composite_cost: sizeCard.composite_cost,
							is_owned: sizeCard.is_owned,
							buyout_price: sizeCard.buyout_price,
							buyout_state: sizeCard.buyout_state,
							seller_uid: sizeCard.seller_uid,
							product_image: sizeCard.product_image,
							available: 0,
							sizes: []
						}
						order.push(map[key])
					}
					map[key].available += sizeCard.available
					if (sizeCard.available > 0) {
						map[key].sizes.push(sizeCard)
					}
					if (!map[key].product_image && sizeCard.product_image) {
						map[key].product_image = sizeCard.product_image
					}
				})
				order.forEach(function(card) {
					card.sizes = self.sortSizeCards(card.sizes)
				})
				return order.filter(function(card) {
					return Number(card.available || 0) > 0
				})
			},
			loadWarehouse() {
				this.$axios.get('api/cloud_warehouse/info').then(res => {
					this.ready = true
					if (res.data.code === 0) {
						var info = res.data.data || {}
						this.warehouseId = info.id || ''
						this.warehouseName = info.name || ''
						if (this.warehouseId) {
							this.loadPromotions()
							this.loadStock()
							this.$nextTick(() => {
								this.bindCartResize()
								if (this.$refs.scanInput) {
									this.$refs.scanInput.focus()
								}
							})
						}
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					this.ready = true
					console.log(err)
				})
			},
			loadPromotions() {
				if (!this.warehouseId) {
					return
				}
				this.$axios.get('api/cloud_warehouse/promotion_list', {
					params: { warehouse_id: this.warehouseId }
				}).then(res => {
					if (res.data.code === 0) {
						this.promotions = (res.data.data && res.data.data.list) || []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			loadStock() {
				if (!this.warehouseId) {
					return
				}
				this.stockLoading = true
				this.$axios.get('api/cloud_warehouse/stock_list', {
					params: {
						warehouse_id: this.warehouseId,
						style_number: this.keyword,
						page: this.stockPage,
						limit: this.stockPageSize || 50
					}
				}).then(res => {
					this.stockLoading = false
					if (res.data.code === 0) {
						var data = res.data.data || {}
						this.cards = this.aggregateByStyle(data.list || [])
						this.stockTotal = data.count || 0
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					this.stockLoading = false
					console.log(err)
				})
			},
			onSearch() {
				this.stockPage = 1
				this.loadStock()
			},
			handleStockPage(page) {
				this.stockPage = page
				this.loadStock()
			},
			focusScan() {
				this.$nextTick(() => {
					if (this.$refs.scanInput) {
						this.$refs.scanInput.focus()
					}
				})
			},
			onCardClick(card) {
				var sizes = ((card && card.sizes) || []).filter(function(item) {
					return item.available > 0
				})
				if (!sizes.length) {
					this.$message.warning('该商品暂无可用库存')
					return
				}
				if (sizes.length === 1) {
					this.addSize(sizes[0])
					return
				}
				this.sizePickCard = card
				this.sizePickShow = true
			},
			onPickSize(item) {
				if (!item || item.available <= 0) {
					this.$message.warning('该尺码暂无可用库存')
					return
				}
				this.addSize(item)
				this.closeSizePick()
			},
			closeSizePick() {
				this.sizePickShow = false
				this.sizePickCard = {}
			},
			addSize(card, extra) {
				if (!card || card.available <= 0) {
					this.$message.warning('该商品暂无可用库存')
					return
				}
				var key = card.key || this.cardKey(card.style_number, card.size)
				var exists = this.cart.filter(function(row) {
					return row.key === key
				})[0]
				if (exists) {
					if (exists.quantity + 1 > card.available) {
						this.$message.warning('可用库存不足')
						return
					}
					exists.quantity += 1
					if (extra && extra.barcode) {
						exists.barcode = extra.barcode
					}
					return
				}
				if (this.cart.length >= 50) {
					this.$message.warning('单次最多提交50条明细')
					return
				}
				this.cart.push({
					key: key,
					stock_id: card.stock_id,
					barcode: extra && extra.barcode ? extra.barcode : '',
					style_number: card.style_number,
					size: card.size,
					quantity: 1,
					sale_price_yuan: this.fenToYuan(card.suggest_price != null ? card.suggest_price : card.retail_price),
					retail_price: card.retail_price,
					composite_cost: card.composite_cost,
					composite_discount: card.composite_discount,
					cost_discount: card.cost_discount,
					is_owned: card.is_owned,
					buyout_price: card.buyout_price,
					buyout_state: card.buyout_state,
					seller_uid: card.seller_uid,
					available: card.available
				})
			},
			removeCart(index) {
				this.cart.splice(index, 1)
			},
			onScan() {
				var code = String(this.barcode || '').trim()
				if (!code) {
					return
				}
				this.$axios.get('api/cloud_warehouse/stock_list', {
					params: {
						warehouse_id: this.warehouseId,
						barcode: code,
						page: 1,
						limit: 20
					}
				}).then(res => {
					if (res.data.code !== 0) {
						this.$message.error(apiMsg(res))
						return
					}
					var list = (res.data.data && res.data.data.list) || []
					var cards = this.aggregateBySize(list)
					if (!cards.length) {
						this.$message.warning('未找到该商品')
						return
					}
					this.addSize(cards[0], { barcode: code })
					this.barcode = ''
					this.focusScan()
				}).catch(err => {
					console.log(err)
				})
			},
			onManualAdd() {
				var style = String(this.manualStyle || '').trim()
				var size = String(this.manualSize || '').trim()
				if (!style || !size) {
					this.$message.warning('请输入款号和尺码')
					return
				}
				this.$axios.get('api/cloud_warehouse/stock_list', {
					params: {
						warehouse_id: this.warehouseId,
						style_number: style,
						page: 1,
						limit: 50
					}
				}).then(res => {
					if (res.data.code !== 0) {
						this.$message.error(apiMsg(res))
						return
					}
					var cards = this.aggregateBySize((res.data.data && res.data.data.list) || []).filter(function(card) {
						return String(card.style_number) === style && String(card.size) === size
					})
					if (!cards.length) {
						this.$message.warning('未找到该商品')
						return
					}
					this.addSize(cards[0])
					this.manualStyle = ''
					this.manualSize = ''
				}).catch(err => {
					console.log(err)
				})
			},
			openConfirm() {
				if (!this.cart.length) {
					this.$message.warning('请先添加商品')
					return
				}
				var items = []
				for (var i = 0; i < this.cart.length; i++) {
					var row = this.cart[i]
					var qty = Number(row.quantity || 0)
					if (qty <= 0) {
						this.$message.warning('销售数量必须大于0')
						return
					}
					var item = { quantity: qty }
					var price = yuanToFen(row.sale_price_yuan)
					if (!isNaN(price) && price > 0) {
						item.sale_price = price
					}
					if (row.barcode) {
						item.barcode = row.barcode
					} else if (row.stock_id) {
						item.stock_id = Number(row.stock_id)
					} else {
						item.style_number = row.style_number
						item.size = row.size
					}
					items.push(item)
				}
				if (items.length > 50) {
					this.$message.warning('单次最多提交50条明细')
					return
				}
				this.confirmItems = items
				this.confirmShow = true
			},
			onConfirmPay() {
				if (this.confirmSubmitting) {
					return
				}
				var items = this.confirmItems || []
				if (!items.length) {
					this.$message.warning('请先添加商品')
					return
				}
				var cartCount = this.cart.length
				this.confirmSubmitting = true
				this.$axios.post('api/cloud_warehouse/sale_create', {
					warehouse_id: this.warehouseId,
					items: JSON.stringify(items)
				}).then(res => {
					this.confirmSubmitting = false
					if (res.data.code === 0) {
						var data = res.data.data || {}
						data.split = (data.items || []).length > cartCount
						this.confirmShow = false
						this.confirmItems = []
						this.applyReceipt(data)
						this.saveLastReceipt()
						this.cart = []
						this.refreshBalance()
						this.loadStock()
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					this.confirmSubmitting = false
					console.log(err)
				})
			},
			closeConfirm(done) {
				this.confirmShow = false
				this.confirmSubmitting = false
				if (typeof done === 'function') {
					done()
				}
			},
			closeReceipt() {
				this.receiptShow = false
				this.focusScan()
			}
		}
	}
</script>

<style scoped lang="less">
	.warehouse-pos {
		height: 100%;
	}

	.empty-guide {
		padding: 80px 20px;
		text-align: center;
		.empty-title {
			font-size: 20px;
			font-weight: 600;
			margin-bottom: 12px;
		}
		.empty-desc {
			color: #909399;
			margin-bottom: 24px;
		}
	}

	.pos-layout {
		height: calc(100% - 72px);
		display: flex;
		min-height: 0;
	}

	.pos-left {
		flex: 1;
		min-width: 0;
		margin-right: 16px;
		display: flex;
		flex-direction: column;
	}

	.pos-toolbar,
	.manual-row {
		display: flex;
		margin-bottom: 8px;
		.el-input {
			flex: 1;
			min-width: 0;
			margin-right: 8px;
		}
	}

	.card-grid {
		flex: 1;
		overflow: auto;
		display: flex;
		flex-wrap: wrap;
		align-content: flex-start;
	}

	.stock-card {
		flex: 1 1 148px;
		max-width: 180px;
		margin: 0 10px 10px 0;
		border: 1px solid #EBEEF5;
		border-radius: 4px;
		cursor: pointer;
		background: #fff;
		.thumb {
			height: 136px;
			background: #F5F7FA;
			img {
				width: 100%;
				height: 100%;
				object-fit: contain;
			}
		}
		.thumb-empty {
			height: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
			color: #C0C4CC;
			font-size: 12px;
		}
		.meta {
			padding: 8px;
			font-size: 12px;
			line-height: 18px;
		}
		.style {
			font-weight: 600;
		}
		.price {
			color: #F56C6C;
		}
		.retail {
			color: #909399;
			text-decoration: line-through;
		}
		.avail {
			color: #909399;
		}
	}

	.size-pick {
		display: flex;
		flex-wrap: wrap;
	}

	.size-chip {
		min-width: 88px;
		margin: 0 8px 8px 0;
		padding: 8px 10px;
		border: 1px solid #DCDFE6;
		border-radius: 4px;
		cursor: pointer;
		font-size: 12px;
		line-height: 18px;
		strong {
			display: block;
			font-size: 14px;
		}
		span {
			display: block;
			color: #909399;
		}
		&:hover {
			border-color: #F65730;
			color: #F65730;
		}
		&.disabled {
			color: #C0C4CC;
			cursor: not-allowed;
			border-color: #EBEEF5;
		}
	}

	.empty-cards {
		color: #909399;
		padding: 24px 0;
	}

	.pager {
		margin-top: 8px;
		text-align: right;
	}

	.pos-right {
		flex: 0 0 420px;
		width: 420px;
		max-width: 420px;
		display: flex;
		flex-direction: column;
		min-height: 0;
	}

	.cart-title {
		font-weight: 600;
		margin-bottom: 8px;
	}

	.cart-body {
		flex: 1;
		min-height: 0;
	}

	.cart-table {
		width: 100%;
	}

	.cart-foot {
		margin-top: 12px;
		font-weight: 600;
		.sub {
			font-weight: 400;
			font-size: 12px;
			color: #909399;
			margin: 6px 0 12px;
		}
	}

	.split-tip,
	.receipt-total {
		margin: 10px 0;
	}

	.split-tip {
		color: #E6A23C;
		font-size: 13px;
	}

	.low-tip {
		color: #E6A23C;
		font-size: 13px;
		margin: 10px 0;
	}

	.confirm-sum {
		margin: 12px 0 8px;
		.sub {
			font-size: 12px;
			color: #909399;
			margin-top: 6px;
		}
	}

	.pay-fen {
		font-size: 22px;
		font-weight: 700;
		margin: 8px 0 4px;
	}

	.confirm-tip {
		font-size: 13px;
		color: #409EFF;
		margin: 6px 0 0;
		&.warn {
			color: #E6A23C;
		}
	}

	.profit-pos {
		color: #67C23A;
	}

	.profit-neg {
		color: #F56C6C;
	}

	.ticket {
		width: 58mm;
		font-size: 12px;
		line-height: 18px;
		margin: 0 0 12px;
		color: #303133;
	}

	.ticket-name {
		font-weight: 600;
		text-align: center;
		margin-bottom: 6px;
	}

	.ticket-line {
		display: flex;
		justify-content: space-between;
	}

	/deep/ .cart-table .el-input-number {
		width: 100%;
	}

	/deep/ .cart-table .el-input-number .el-input__inner,
	/deep/ .cart-table .el-input__inner {
		padding: 0 4px;
		text-align: center;
	}
</style>

<style lang="less">
	@media print {
		body * {
			visibility: hidden;
		}
		#cw-ticket,
		#cw-ticket * {
			visibility: visible;
		}
		#cw-ticket {
			position: absolute;
			left: 0;
			top: 0;
			width: 58mm;
			font-size: 12px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/buyer/warehouse/pos.vue